import type { ChooseDoubleRewardsChoice } from '../utils/loyaltyChooseDoubleRewardsState'
import getLoyaltyCanEnrolChooseDoubleRewards from '../selectors/getLoyaltyCanEnrolChooseDoubleRewards'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyChooseDoubleRewardsCampaignMetadata from '../selectors/getLoyaltyChooseDoubleRewardsCampaignMetadata'
import getLoyaltyChooseDoubleRewardsMemberState from '../selectors/getLoyaltyChooseDoubleRewardsMemberState'

/**
 * Reads campaign data without checking takeover eligibility.
 * Use when caller already controls eligibility, e.g. takeover config
 * Other callers should use {@link useLoyaltyActiveChooseDoubleRewards}.
 */
function useLoyaltyChooseDoubleRewards(choice?: ChooseDoubleRewardsChoice) {
  const config = useAppSelector(getLoyaltyChooseDoubleRewardsCampaignMetadata)
  const memberState = useAppSelector(getLoyaltyChooseDoubleRewardsMemberState)

  const canEnrol = useAppSelector(state => getLoyaltyCanEnrolChooseDoubleRewards(state, choice))

  return {
    memberState,
    canEnrol,
    endsAt: config?.endsAt,
  }
}

export default useLoyaltyChooseDoubleRewards
